import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnvironmentTableComponent } from '../../environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../../environment-paginator/environment-paginator.component';

@Component({
  selector: 'app-base-image-detail-popup',
  templateUrl: './base-image-detail-popup.component.html',
  styleUrl: './base-image-detail-popup.component.scss',
  standalone: false
})
export class BaseImageDetailPopupComponent {
  @ViewChild(EnvironmentTableComponent) tableRef!: EnvironmentTableComponent;
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef!: EnvironmentPaginatorComponent;

  detailColumnKeys = ['componentName', 'fromRef', 'toRef', 'status'];
  pageIndex = 0;
  paginationSize = 10;
  searchTerm: string = '';
  searchedResult: unknown[] = [];

  displayColumns = [
    { key: 'componentName', name: 'BASE_IMAGE.COMPONENT_NAME', type: 'text', sortable: true, visible: true, disable: true },
    { key: 'fromRef', name: 'BASE_IMAGE.FROM', type: 'text', sortable: true, visible: true, disable: true },
    { key: 'toRef', name: 'BASE_IMAGE.TO', type: 'text', sortable: true, visible: true, disable: true },
    { key: 'status', name: 'INSTANCE_DETAILS.STATUS', type: 'status', sortable: true, visible: true, disable: true }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { row: any; detail: any[]; loading: boolean },
    public dialogRef: MatDialogRef<BaseImageDetailPopupComponent>
  ) {}

  get detail(): any[] {
    return this.data.detail;
  }

  get baseImageData(): any[] {
    return this.data.detail;
  }

  get showLoader(): boolean {
    return this.data.loading;
  }

  search(term: string): void {
    this.searchTerm = term;
    this.pageIndex = 0;
  }

  searchedItems(result: unknown[]): void {
    this.searchedResult = result;
  }

  onPageChange(event: { pageSize: number; pageIndex: number }): void {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }
}
